import { faLink } from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@mantine/core'
import React from 'react'

import { useQueryGetBookingById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Modal } from '@flecto/ui'

import { ButtonBookingFlectoLinkCopy } from '../../../bookings'

export type ModalBookingActionFlectoLinkProps = {
  bookingId?: ParameterID
}

export function ModalBookingActionFlectoLink({
  bookingId,
}: ModalBookingActionFlectoLinkProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_actions' })
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })

  const { data: booking, isLoading } = useQueryGetBookingById({ bookingId })

  return (
    <Modal size='sm'>
      <Modal.Icon icon={faLink} color='green' />
      <Modal.Title>{t('modal_flecto_link_title')}</Modal.Title>
      <Modal.Subtitle>{t('modal_flecto_link_description')}</Modal.Subtitle>
      <Modal.Content>
        <ButtonBookingFlectoLinkCopy
          fullWidth
          variant='outline'
          booking={booking}
          loading={isLoading}
        />
      </Modal.Content>
      <Modal.Close />
      <Modal.Cancel color='brand' variant='filled'>
        {tActions('close')}
      </Modal.Cancel>
    </Modal>
  )
}
